import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  return <div className="mt-7 flex flex-col items-center" role="timer" aria-live="off" data-id="element-2" data-mp="3c0um15qdek6u">
      <p className={`flex items-center gap-2 text-xs font-bold uppercase tracking-wider ${dark ? "text-gold" : "text-brand-700"}`} data-id="element-3" data-mp="3h1ifdy22nd48">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-4" data-mp="3262n9yl1xrah" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-5" data-mp="10cbtjiezz3fb">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-6" data-mp="10aihtopj1t0g" data-mpi={i}>
            {i > 0 && <span className={`pt-3 font-serif text-3xl font-black ${dark ? "text-white/70" : "text-brand-900"}`} data-id="element-7" data-mp="15awlyvo0cit7">:</span>}
            <div className="flex flex-col items-center" data-id="element-8" data-mp="t23dxk2j3pg3">
              <span className={`flex h-[68px] w-[68px] items-center justify-center rounded-xl font-serif text-[34px] font-black tabular-nums sm:h-20 sm:w-20 sm:text-4xl ${dark ? "bg-white text-brand-900" : "bg-brand-900 text-white"}`} data-id="element-9" data-mp="t1k6wyef2lgu">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wide ${dark ? "text-brand-100" : "text-muted"}`} data-id="element-10" data-mp="a3hee9mnu6ea">
                {u.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}